import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EquipmentModelService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
import { ModalEquipmentModelComponent } from '../modal-equipment-model/modal-equipment-model.component';

@Component({
  selector: 'meu-equipment-model-management',
  templateUrl: './equipment-model-management.component.html',
  styleUrls: ['./equipment-model-management.component.scss'],
})
export class EquipmentModelManagementComponent implements OnInit {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private equipmentModelService: EquipmentModelService
  ) {}

  displayedColumns: string[] = [
    'Index',
    'ModelCode',
    'EquipmentCategory',
    'EquipmentType',
    'BrandName',
    'PrefixCode',
    'Actions',
  ];
  prefixMap: { [modelId: string]: string } = {};
  lstAll: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  host: any;
  filter: any = '';
  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filter = '(model_code|description|engine_type|transmission_type|mast_type)@=*' + value;
        this.getAll();
      });
    this.getAll();
  }

  public keyUp = new Subject<KeyboardEvent>();

  getAll() {
    this.equipmentModelService
      .apiEquipmentModelsGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAll = res.data.collection;
          this.total = res.data.total;
          this.host = environment.backendhost;
          this.prefixMap = {};
          for (const m of this.lstAll) {
            const prefixes = m.prefixes || [];
            this.prefixMap[m.id] = prefixes.length > 0
              ? prefixes.map((p: any) => p.prefix_code).filter((c: any) => c).join(', ')
              : '';
          }
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAll();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAll();
  }

  openModal(id) {
    const dialogRef = this.dialog.open(ModalEquipmentModelComponent, {
      width: '900px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới dòng xe thành công');
            this.getAll();
          } else {
            this.toastr.success('Chỉnh sửa dòng xe thành công');
            this.getAll();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }

  deleteItem(ID) {
    const title = 'Xóa dòng xe';
    const description = 'Bạn có chắc chắn muốn xóa dòng xe này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.equipmentModelService.apiEquipmentModelsIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá dòng xe thành công');
            this.getAll();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }
}
